import {
  Box,
  ClipboardPenLine,
  Container,
  FileInput,
  FileOutput,
  ListFilter,
  Package,
  Receipt,
  Scale,
  Store,
} from 'lucide-react';

import { SalesRootLayout } from './_components/_layouts/SalesRootLayout';
import { BookingDetailView } from './_components/bookings/_BookingDetailView';
import { BookingsListView } from './_components/bookings/_BookingsListView';
import { ContainerDetailView } from './_components/containers/_ContainerDetailView';
import { ContainersListView } from './_components/containers/_ContainersListView';
import { LoadDetailView } from './_components/loads/_LoadDetailView';
import { LoadsListView } from './_components/loads/_LoadsListView';
import { PositionsListView } from './_components/positions/_PositionsListView';
import { PurchaseOrderDetailView } from './_components/purchase-orders/_PurchaseOrderDetailView';
import { PurchaseOrderListView } from './_components/purchase-orders/_PurchaseOrdersListView';
import { SalesOrderDetailView } from './_components/salesOrders/_SalesOrderDetailView';
import { SalesOrderListView } from './_components/salesOrders/_SalesOrdersListView';
import { ScaleTicketDetailView } from './_components/scale-ticket-pro/_ScaleTicketDetailView';
import { ScaleTicketListView } from './_components/scale-ticket-pro/_ScaleTicketListView';
import { SortingQueueView } from './_components/sorting/_SortingQueueView';
import { TransactionsListView } from './_components/transactions/_TransactionsListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/trade';

export const tradeRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.trade.root,
    icon: Store,
  },
  salesOrders: {
    path: `${basePath}/orders` as const,
    label: (t) => t.menu.trade.salesOrders,
    icon: FileOutput,
    component: SalesOrderListView,
    requiredPermission: 'salesOrderRead',
  },
  salesOrderDetail: {
    path: `${basePath}/orders/:id` as const,
    component: SalesOrderDetailView,
  },
  purchaseOrders: {
    path: `${basePath}/purchase-orders`,
    label: (t) => t.menu.trade.purchaseOrders,
    icon: FileInput,
    component: PurchaseOrderListView,
    requiredPermission: 'purchaseOrderRead',
  },
  purchaseOrderDetail: {
    path: `${basePath}/purchase-orders/:id`,
    component: PurchaseOrderDetailView,
  },
  bookings: {
    path: `${basePath}/bookings` as const,
    label: (t) => t.menu.trade.bookings,
    icon: ClipboardPenLine,
    component: BookingsListView,
    requiredPermission: 'bookingRead',
  },
  bookingDetail: {
    path: `${basePath}/bookings/:id` as const,
    component: BookingDetailView,
  },
  loads: {
    path: `${basePath}/loads` as const,
    label: (t) => t.menu.trade.loads,
    icon: Container,
    component: LoadsListView,
    requiredPermission: 'loadRead',
  },
  loadDetail: {
    path: `${basePath}/loads/:id` as const,
    component: LoadDetailView,
  },
  containers: {
    path: `${basePath}/containers`,
    label: (t) => t.menu.trade.containers,
    icon: Box,
    component: ContainersListView,
    requiredPermission: 'containerRead',
  },
  containerDetail: {
    path: `${basePath}/containers/:id`,
    component: ContainerDetailView,
  },
  positions: {
    path: `${basePath}/positions`,
    label: (t) => t.menu.trade.positions,
    icon: Package,
    component: PositionsListView,
    requiredPermission: 'itemPositionRead',
  },
  scaleTickets: {
    path: `${basePath}/scale-tickets`,
    label: (t) => t.menu.trade.scaleTickets,
    icon: Scale,
    component: ScaleTicketListView,
    requiredPermission: 'purchaseLoadRead',
  },
  scaleTicketDetail: {
    path: `${basePath}/scale-tickets/:id`,
    component: ScaleTicketDetailView,
  },
  transactions: {
    path: `${basePath}/transactions`,
    label: (t) => t.menu.trade.transactions,
    icon: Receipt,
    component: TransactionsListView,
  },
  sortingQueue: {
    path: `${basePath}/sorting`,
    label: (t) => t.menu.trade.sortingQueue,
    icon: ListFilter,
    component: SortingQueueView,
  },
});

// prettier-ignore
const tradeNav = createModuleNav(($) =>
  $(tradeRoutes.root, [
    // $(tradeRoutes.overview),
    $(tradeRoutes.scaleTickets),
    $(tradeRoutes.scaleTicketDetail),
    $(tradeRoutes.transactions),
    $(tradeRoutes.salesOrders),
    $(tradeRoutes.salesOrderDetail),
    $(tradeRoutes.purchaseOrders),
    $(tradeRoutes.purchaseOrderDetail),
    $(tradeRoutes.sortingQueue),
    $(tradeRoutes.bookings),
    $(tradeRoutes.bookingDetail),
    $(tradeRoutes.loads),
    $(tradeRoutes.loadDetail),
    $(tradeRoutes.containers),
    $(tradeRoutes.containerDetail),
    $(tradeRoutes.positions),
  ]),
);

export const tradeModule = createAppModule({
  routes: tradeRoutes,
  nav: tradeNav,
  layout: SalesRootLayout,
});
